<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Mortgage Details</h5>
  <div class="d-flex align-items-center gap-2 ms-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openAuditForForm()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" *ngIf="!generatingLetters" (click)="close()"></button>
  </div>
</div>

<div class="modal-body">

  <div *ngIf="!loaded" class="d-flex justify-content-center py-5">
    <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>


  <form [formGroup]="mortgageDetails" autocomplete="off" *ngIf="mortgageDetails && loaded">

    <!-- Lender -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Lifetime Mortgage Lender</label>
        <select class="form-select" formControlName="lenderId" (change)="updateField()">
          <option *ngFor="let lender of lenders" [ngValue]="lender.id">{{lender.name}}</option>
          <option [ngValue]="0">Other</option>
        </select>
      </div>
      <div class="col-sm-6" [hidden]="mortgageDetails.controls['lenderId'].value != 0">
        <label class="form-label fw-semibold">Other Lender</label>
        <textarea class="form-control" maxlength="250" rows="2"
          formControlName="otherLender" (change)="updateField()"></textarea>
      </div>
    </div>

    <!-- Lenders Solicitor -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Lenders Solicitor</label>
        <select class="form-select" formControlName="lendersSolicitorId"
          (change)="updateField(); updateSolEmails()">
          <option *ngFor="let ls of lendersSolicitors" [ngValue]="ls.id">{{ls.name}}</option>
          <option [ngValue]="0">Other</option>
        </select>
      </div>
      <div class="col-sm-6" [hidden]="mortgageDetails.controls['lendersSolicitorId'].value != 0">
        <label class="form-label fw-semibold">Other Lenders Solicitor</label>
        <input class="form-control" maxlength="50" formControlName="otherLendersSolicitor" (change)="updateField()">
      </div>
    </div>

    <div class="row mb-3"
      [hidden]="mortgageDetails.controls['lendersSolicitorId'].value == null || mortgageDetails.controls['lendersSolicitorId'].value == -1">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Lenders Solicitor Email</label>
        <select class="form-select" formControlName="lendersSolicitorEmailId" (change)="updateField()">
          <option *ngFor="let email of lendersSolicitorEmails" [ngValue]="email.id">{{email.emailAddress}}</option>
          <option [ngValue]="0">Other</option>
        </select>
      </div>
      <div class="col-sm-6" *ngIf="mortgageDetails.controls['lendersSolicitorEmailId'].value == 0">
        <label class="form-label fw-semibold">Other Lenders Solicitor Email</label>
        <input class="form-control" formControlName="otherLendersSolicitorEmail" (change)="updateField()">
      </div>
    </div>

    <!-- Offer / Product -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Lender Solicitor Reference</label>
        <input class="form-control" formControlName="lenderSolicitorReference" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Offer Expiry Date (Key Date)</label>
        <div class="input-group">
          <input class="form-control" formControlName="offerExpiryDate"
            (dateInput)="updateField()" (dateChange)="updateField()" readonly>
          <button type="button" class="btn btn-outline-secondary" (click)="openKeyDates()">
            <fa-icon [icon]="faCalendarDay"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Name of Product</label>
        <input class="form-control" formControlName="nameOfProduct" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Fixed Interest Rate</label>
        <input class="form-control" formControlName="fixedInterestRate" (change)="updateField()">
      </div>
    </div>

    <!-- Loan Amounts -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Full Loan Amount</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="fullLoanAmount" (change)="updateField()">
        </div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Final Amount Released</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="finalAmountReleased" (change)="updateField()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Drawdown Available</label>
        <app-yes-no-form-toggle class="d-block" formControlName="drawdownAvailable" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6" [hidden]="mortgageDetails.controls['drawdownAvailable'].value != 1">
        <label class="form-label fw-semibold">Drawdown Details</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="drawdownAvailableDetails" (change)="updateField()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Cashback Available</label>
        <app-yes-no-form-toggle class="d-block" formControlName="cashbackAvailable" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6" [hidden]="mortgageDetails.controls['cashbackAvailable'].value != 1">
        <label class="form-label fw-semibold">Cashback Details</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="cashbackAvailableDetails" (change)="updateField()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Contribution to Legal Fees</label>
        <app-yes-no-form-toggle class="d-block" formControlName="contributionToLegalFees" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6" [hidden]="mortgageDetails.controls['contributionToLegalFees'].value != 1">
        <label class="form-label fw-semibold">Contribution Details</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="contributionToLegalFeesDetails" (change)="updateField()">
        </div>
      </div>
    </div>

    <!-- Mortgage Terms -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">How long can the property be vacated</label>
        <select class="form-select" formControlName="propertyVacatedLength" (change)="updateField()">
          <option [ngValue]="-1"></option>
          <option [ngValue]="1">30 days</option>
          <option [ngValue]="2">2 months</option>
          <option [ngValue]="3">3 months</option>
          <option [ngValue]="4">6 months</option>
        </select>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Term of Mortgage</label>
        <input class="form-control" formControlName="termOfMortgage" (change)="updateField()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Agreed interest repayment details</label>
        <app-yes-no-form-toggle class="d-block" formControlName="agreedInterestRepayment" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6" [hidden]="mortgageDetails.controls['agreedInterestRepayment'].value != 1">
        <label class="form-label fw-semibold">Details</label>
        <input class="form-control" formControlName="agreedInterestRepaymentDetails" (change)="updateField()">
      </div>
    </div>

    <!-- Occupiers -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Any Occupiers?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="anyOccupiers" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="mortgageDetails.controls['anyOccupiers'].value != 1">
      <div formArrayName="occupiers">
        <div *ngFor="let occupier of occupiers.controls; let i = index" class="border rounded p-3 mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="fw-bold mb-0">Occupier {{i + 1}}</h6>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeOcc(i)">
              <fa-icon [icon]="faTrashAlt"></fa-icon>
            </button>
          </div>
          <div [formGroupName]="i">
            <div class="row mb-3">
              <div class="col-sm-6">
                <label class="form-label fw-semibold">Name</label>
                <input class="form-control" maxlength="100" formControlName="occupierName" (change)="updateField()">
              </div>
              <div class="col-sm-6">
                <label class="form-label fw-semibold">DOB</label>
                <input type="date" class="form-control" formControlName="occupierDOB"
                  (change)="updateField()">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-6">
                <label class="form-label fw-semibold">Relationship to Client</label>
                <input class="form-control" maxlength="100" formControlName="occupierRelationshipToClient" (change)="updateField()">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-success btn-sm" (click)="addOcc()">
          <fa-icon [icon]="faPlus"></fa-icon> Occupier
        </button>
      </div>
    </div>

    <!-- Building Insurance -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Building Insurance Sum Required</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="buildingInsuranceSumRequired" (change)="updateField()">
        </div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Lenders Interest Noted Required</label>
        <app-yes-no-form-toggle class="d-block" formControlName="lendersInterestNotedRequired" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div class="row mb-3" [hidden]="mortgageDetails.controls['lendersInterestNotedRequired'].value != 1">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Lenders Interest Details</label>
        <input class="form-control" formControlName="lendersInterestNotedRequiredDetails" (change)="updateField()">
      </div>
    </div>

    <!-- Special Conditions -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Has Special Conditions?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="hasSpecialConditions" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="mortgageDetails.controls['hasSpecialConditions'].value != 1">
      <div formArrayName="specialConditions">
        <div *ngFor="let sc of specialConditions.controls; let i = index" class="border rounded p-3 mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="fw-bold mb-0">Special Condition {{i + 1}}</h6>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeSC(i)">
              <fa-icon [icon]="faTrashAlt"></fa-icon>
            </button>
          </div>
          <div [formGroupName]="i">
            <textarea class="form-control" formControlName="specialCondition"
              rows="3" (change)="updateField()"></textarea>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-success btn-sm" (click)="addSC()">
          <fa-icon [icon]="faPlus"></fa-icon> Special Condition
        </button>
      </div>
    </div>

    <!-- Consultant -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Consultant</label>
        <div class="input-group"> <!--- this select needs to be read only - cant disable or wont be included in the form - so just style-->
          <select class="form-select" formControlName="externalConsultantId" style="pointer-events: none; background-color: #e9ecef;"
            (change)="updateField()"> 
            <option *ngFor="let c of externalConsultants" [ngValue]="c.id">{{c.name}}</option>
          </select>
          <button type="button" class="btn btn-outline-success" (click)="selectConsultant()">
            Select Consultant
          </button>
        </div>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button *ngIf="!generatingLetters" type="button" class="btn btn-success" (click)="createLetters()">
    Generate Letters
  </button>
  <button *ngIf="generatingLetters" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Generating...
  </button>
</div>